import growthMarketerImg from "public/images/landing/marketers/growth_marketer.png";
import brandMarketerImg from "public/images/landing/marketers/brand_marketer.png";
import performanceMarketerImg from "public/images/landing/marketers/performance_marketer.png";
import contentMarketerImg from "public/images/landing/marketers/content_marketer.png";

export const marketersData = [
  {
    title: "그로스 마케터",
    desc: "데이터 해석 능력을 바탕으로 지표를 개선하고\n비즈니스의 성장을 주도합니다.",
    img: growthMarketerImg,
  },
  {
    title: "브랜드 마케터",
    desc: "고객과 비즈니스를 연결하는 캠페인 전략으로\n브랜드의 가치를 완성하세요.",
    img: brandMarketerImg,
  },
  {
    title: "퍼포먼스 마케터",
    desc: "목표와 타겟, 예산에 따른 광고 운영을 넘어\n데이터를 통한 최고의 성과 도출을 가능하게 합니다.",
    img: performanceMarketerImg,
  },
  {
    title: "콘텐트 마케터",
    desc: "데이터에 기반한 콘텐츠로 고객 여정을 설계하고,\n정량적 지표를 바탕으로 전략을 수립합니다.",
    img: contentMarketerImg,
  },
];
